import { render, staticRenderFns } from "./DreamView.vue?vue&type=template&id=7e6612f4&scoped=true&"
import script from "./DreamView.vue?vue&type=script&lang=ts&"
export * from "./DreamView.vue?vue&type=script&lang=ts&"
import style0 from "./DreamView.vue?vue&type=style&index=0&id=7e6612f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6612f4",
  null
  
)

export default component.exports